import React, { useCallback } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  // Function to toggle fullscreen mode
  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  }, []);

  // Function to navigate to home
  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: 'rgb(108, 69, 185)',
        px: 2,
        py: 1,
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between',p:0 }}>
        {/* Left: Logo and Company Name */}
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            alt="Logo"
            src="/logo192.png" // Replace with your logo path
            sx={{ width: 32, height: 32 }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 600, color: 'white' }}
          >
            Wizzo Dine
          </Typography>
        </Box>

        {/* Right: Fullscreen and Home Icons */}
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton color="inherit" onClick={toggleFullScreen}>
            <FullscreenIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleHomeClick}>
            <HomeIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
